$(document).ready(function () {
  var getval = $(".choose-Inhalt .select-option-1").val();
  $(".choose-Inhalt .first-select-option").val(getval);

  var foption = $(".choose-Farbe .first-select-option").text();
  var soption = $(".choose-Inhalt .first-select-option").val();

  var trimfoption = $.trim(foption);
  var trimsoption = $.trim(soption);

  // console.log(foption);
  if (trimfoption == "Bitte Farbe auswählen") {
    //console.log(trimfoption);
    $(".product-form__submit").prop("disabled", true);
  }

  $(document).on("click", '.megamenu-maincategory>a[href="#"]', function () {
    event.preventDefault();
  });

  var popup_id = localStorage.getItem("popup_id");
  $('.catalog-img[data-index="' + popup_id + '"]').trigger("click");

  setTimeout(function () {
    localStorage.removeItem("popup_id");
  }, 1100000);

  $(".arztzeugnis_button").click(function () {
    $("#shopify-section-header").css("z-index", "1");

    $(".form-drawer.prescription_pop").addClass("open");
    $("body").addClass("formopen tst");
  });

  // if($('.page-uber-uns #shopify-section-about-job').length > 0){
  //   if(window.location.href.indexOf('#jobs') != -1){
  //     var position = $('.page-uber-uns #shopify-section-about-job').offset().top - 150;
  //     $("body, html").animate({
  //   		scrollTop: position
  //   	}, 2000 );
  //   }
  // }

  if ($(".page-uber-uns").length > 0) {
    var hash = window.location.hash;
    if (hash != "") {
      var position = $(hash).offset().top - 180;
      $("body, html").animate(
        {
          scrollTop: position,
        },
        800
      );
    }
  }
  $(".jobs").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#shopify-section-about-job").offset().top - 200,
      },
      2000
    );
  });
  $(document).on("click", ".mitarbeitende a", function () {
    var hash = this.hash;
    if (hash != "") {
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top - 200,
        },
        800
      );
    }
  });

  $(".select-for-radio select").change(function () {
    var value = $(this).val();
    var find_radio = $(this)
      .parents(".product-form__input")
      .find("input:radio[data-value=" + value + "]")
      .val();
    $(this)
      .parents(".product-form__input")
      .find("input:radio")
      .attr("checked", false);

    if (find_radio) {
      $(this)
        .parents(".product-form__input")
        .find("input:radio[data-value=" + value + "]")
        .attr("checked", "checked");
    }
    //console.log(find_radio);
  });

  $(".product_attribute_list_items").hide();
  $(".product_attribute_list")
    .find(".product_attribute_list_items:lt(4)")
    .show()
    .addClass("show-item");
  $(".ShowLess").hide();

  $(".ShowMore").click(function (ev) {
    $(ev.currentTarget).parent().find(".product_attribute_list_items").show();
    $(this).hide();
  });

  $("form.newsletter-form").submit(function () {
    var set_cookie = $(this)
      .parents(".catalog-border")
      .find(".catalog-img")
      .attr("data-index");
    localStorage.setItem("popup_id", set_cookie);
  });

  $("#product_form_btn_pre").click(function () {
    console.log($(".line-item-property__field input").val());
    if ($(".line-item-property__field input").val() == "") {
    } else {
      $(".product-form form").submit();
    }
  });
  $("#certificate-email").click(function () {
    $(".product-form form").submit();
  });

  $(".Courses-subject #product-grid").html(
    $(".Courses-subject #product-grid .course-main").sort(function (x, y) {
      var value_x = $(x).data("index");
      var arr_x = [];
      arr_x = value_x;

      var value_y = $(y).data("index");
      var arr_y = [];
      arr_y = value_y;

      var arel = parseInt(arr_x);
      var brel = parseInt(arr_y);

      return arel < brel ? -1 : 1;
    })
  );

  $(document).on("click", ".facet-filters__sort", function () {
    setTimeout(function () {
      var active_val = $(
        ".collection-filter .collection-filter-inner span.active"
      ).attr("data-value");
      var lengths = $(".live-course-block a." + active_val).length;
      $(".collection-kurse .product-count__text").text(lengths + " kurse");
      console.log("filters__sort");

      var parameters = getQueryStringParameters();
      if (isEmpty(parameters) == false) {
        $.each(parameters, function (key, value) {
          if (key == "sort_by" && value == "created-ascending") {
            $(".Courses-subject #product-grid").html(
              $(".Courses-subject #product-grid .course-main").sort(function (
                x,
                y
              ) {
                var value_x = $(x).data("index");
                var arr_x = [];
                arr_x = value_x;

                var value_y = $(y).data("index");
                var arr_y = [];
                arr_y = value_y;

                var arel = parseInt(arr_x);
                var brel = parseInt(arr_y);

                return arel < brel ? -1 : 1;
              })
            );
          }

          if (key == "sort_by" && value == "created-descending") {
            $(".Courses-subject #product-grid").html(
              $(".Courses-subject #product-grid .course-main").sort(function (
                x,
                y
              ) {
                var value_x = $(x).data("index");
                var arr_x = [];
                arr_x = value_x;

                var value_y = $(y).data("index");
                var arr_y = [];
                arr_y = value_y;

                var arel = parseInt(arr_x);
                var brel = parseInt(arr_y);

                return arel > brel ? -1 : 1;
              })
            );
          }
        }); // each end
      } // if end
    }, 2000);
  });

  $(".kurse-bottom #program .product-list-wrap").html(
    $(".kurse-bottom #program .product-list-wrap .kurse-program-single").sort(
      function (x, y) {
        var value_x = $(x).data("index");
        var arr_x = [];
        arr_x = value_x;

        var value_y = $(y).data("index");
        var arr_y = [];
        arr_y = value_y;

        var arel = parseInt(arr_x);
        var brel = parseInt(arr_y);

        return arel < brel ? -1 : 1;
      }
    )
  );

  var click = 0;
  $(".menu-title.nav").hover(function () {
    click = 0;
  });

  $(document).on(
    "click",
    '.header__inline-menu a[href="/#"], .header__inline-menu a[href="/fr#"],.header__inline-menu a[href="/it#"], .megamenu-li-link a[href="/fr#"], .megamenu-child-li-link a[href="/fr#"], .megamenu-li-link a[href="/it#"], .megamenu-child-li-link a[href="/it#"], .list-menu a[href="/#"], .list-menu a[href="/it#"], .list-menu a[href="/fr#"]',
    function () {
      event.preventDefault();
    }
  );
  $(document).on("click, mouseenter", ".list-menu .list-menu-li", function () {
    //console.log($('.megamenu.derma-megamenu').attr('class'));
    $(".megamenu.derma-megamenu").removeClass("subsubmenu-active");
    $(".megamenu.derma-megamenu")
      .find(".megamenu-sub-all-2")
      .removeClass("subsubmenu-active");

    $(".megamenu.derma-megamenu").removeClass("submenu-active");
    $(".megamenu.derma-megamenu")
      .find(".megamenu-sub-all-2")
      .removeClass("submenu-active");

    $(".megamenu.derma-megamenu .megamenu-li").removeClass("active");
  });

  $(document).on(
    "click, mouseenter",
    ".megamenu.derma-megamenu .megamenu-li .megamenu-li-link",
    function () {
      $(".megamenu.derma-megamenu .megamenu-li")
        .not($(this).parent())
        .removeClass("active");
      //     $('.megamenu.derma-megamenu .megamenu-li').not($(this).parent()).removeClass('menu-clicked');

      $(this).parent().toggleClass("active");
      $(this).parents(".megamenu.derma-megamenu").addClass("menu-active");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2 .megamenu-text-block")
        .addClass("hidden");

      $(this)
        .parents(".megamenu.derma-megamenu.produkte")
        .removeClass("subsubmenu-active");
      $(this)
        .parents(".megamenu.derma-megamenu.produkte")
        .find(".megamenu-sub-all-2")
        .removeClass("subsubmenu-active");

      //     $(this).parents('.megamenu.behandlungen.derma-megamenu').removeClass('has-text-block');
      //     $(this).parents('.megamenu.behandlungen.derma-megamenu').find('.megamenu-sub-all-2').removeClass('has-text-block');
      $(".megamenu-child-li").removeClass("active");

      if ($(this).parent().hasClass("active")) {
        $(this).parents(".megamenu.derma-megamenu").addClass("submenu-active");
        $(this)
          .parents(".megamenu.derma-megamenu")
          .find(".megamenu-sub-all-2")
          .addClass("submenu-active");
      } else {
        $(this)
          .parents(".megamenu.derma-megamenu")
          .removeClass("submenu-active");
        $(this)
          .parents(".megamenu.derma-megamenu")
          .find(".megamenu-sub-all-2")
          .removeClass("submenu-active");
      }
      click = click + 1;
      var that = $(this);
      // get window height
      var windowWidth = $(this).siblings(".megamenu-child-ul").height();
      var windowWidthmain = $(this).parents(".menuwrap-block").height();

      var windowWidth = windowWidth + 30;

      //      console.log(windowWidth,windowWidthmain);
      if (click == 1) {
        if (windowWidth > windowWidthmain) {
          if (that.parent().hasClass("active") == true) {
            $(this)
              .parents(".megamenu.derma-megamenu")
              .css("min-height", windowWidth + "px");
          } else {
            $(this)
              .parents(".megamenu.derma-megamenu")
              .css("min-height", windowWidth + "px");
          }
        } else {
          $(this)
            .parents(".megamenu.derma-megamenu")
            .css("min-height", windowWidth + "px");
        }
      } else {
        if (windowWidth < windowWidthmain) {
          //         console.log(that.parent().hasClass('active'));
          if (that.parent().hasClass("active") == true) {
            $(this)
              .parents(".megamenu.derma-megamenu")
              .css("min-height", windowWidthmain + "px");
          } else {
            $(this)
              .parents(".megamenu.derma-megamenu")
              .css("min-height", windowWidth + "px");
          }
        } else {
          if (that.parent().hasClass("active") == true) {
            $(this)
              .parents(".megamenu.derma-megamenu")
              .css("min-height", windowWidth + "px");
          } else {
            $(this)
              .parents(".megamenu.derma-megamenu")
              .css("min-height", windowWidthmain + "px");
          }
        }
      }

      var handle = $(this).attr("data-handle");
      var current_locale_code = $("input#LocaleSelector").val();
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2 .megamenu-text-block")
        .addClass("hidden");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .find(`[data-handle='${handle}']`)
        .find(".megamenu-text-block-inner .lang")
        .addClass("hidden");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .find(`[data-handle='${handle}']`)
        .removeClass("hidden");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .find(`[data-handle='${handle}']`)
        .find("." + current_locale_code + "")
        .removeClass("hidden");
      //      $(this).parents('.megamenu.derma-megamenu').addClass('subsubmenu-active');
      $(this)
        .parents(".megamenu.behandlungen.derma-megamenu")
        .addClass("has-text-block");
      //      $(this).parents('.megamenu.derma-megamenu').find('.megamenu-sub-all-2').addClass('subsubmenu-active');
      $(this)
        .parents(".megamenu.behandlungen.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .addClass("has-text-block");
    }
  );

  $(document).on(
    "click, mouseenter",
    ".megamenu.derma-megamenu .megamenu-child-ul .megamenu-child-li-link",
    function () {
      $(".megamenu.derma-megamenu .megamenu-child-li")
        .not($(this).parent())
        .removeClass("active");
      $(this).parent().toggleClass("active");

      var handle = $(this).attr("data-handle");
      var current_locale_code = $("input#LocaleSelector").val();

      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2 .megamenu-text-block")
        .addClass("hidden");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .find(`[data-handle='${handle}']`)
        .find(".megamenu-text-block-inner .lang")
        .addClass("hidden");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .find(`[data-handle='${handle}']`)
        .removeClass("hidden");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .find(`[data-handle='${handle}']`)
        .find("." + current_locale_code + "")
        .removeClass("hidden");

      if ($(this).hasClass("has-submenu")) {
        $(this)
          .parents(".megamenu.derma-megamenu")
          .addClass("subsubmenu-active");
        $(this)
          .parents(".megamenu.behandlungen.derma-megamenu")
          .addClass("has-text-block");
        $(this)
          .parents(".megamenu.derma-megamenu")
          .find(".megamenu-sub-all-2")
          .addClass("subsubmenu-active");
      } else {
        $(this)
          .parents(".megamenu.derma-megamenu")
          .removeClass("subsubmenu-active");
        $(this)
          .parents(".megamenu.behandlungen.derma-megamenu")
          .removeClass("has-text-block");
        $(this)
          .parents(".megamenu.derma-megamenu")
          .find(".megamenu-sub-all-2")
          .removeClass("subsubmenu-active");
      }

      $(this)
        .parents(".megamenu.behandlungen.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .addClass("has-text-block");
      $(this)
        .parents(".megamenu.derma-megamenu")
        .find(".megamenu-sub-all-2")
        .find(`[data-handle='${handle}']`)
        .removeClass("hidden");

      /*if($(this).parent().hasClass('active')) {
      $(this).parents('.megamenu.derma-megamenu').addClass('subsubmenu-active');
      $(this).parents('.megamenu.behandlungen.derma-megamenu').addClass('has-text-block');
      $(this).parents('.megamenu.derma-megamenu').find('.megamenu-sub-all-2').addClass('subsubmenu-active');
      $(this).parents('.megamenu.behandlungen.derma-megamenu').find('.megamenu-sub-all-2').addClass('has-text-block');
      $(this).parents('.megamenu.derma-megamenu').find('.megamenu-sub-all-2').find(`[data-handle='${handle}']`).removeClass('hidden');
    }else{
      $(this).parents('.megamenu.derma-megamenu').removeClass('subsubmenu-active');
      $(this).parents('.megamenu.behandlungen.derma-megamenu').removeClass('has-text-block');
      $(this).parents('.megamenu.derma-megamenu').find('.megamenu-sub-all-2').removeClass('subsubmenu-active');
      $(this).parents('.megamenu.behandlungen.derma-megamenu').find('.megamenu-sub-all-2').removeClass('has-text-block');
      $(this).parents('.megamenu.derma-megamenu').find('.megamenu-sub-all-2').find(`[data-handle='${handle}']`).addClass('hidden');
    }*/
    }
  );

  $("#contact-form-product").click(function () {
    $(".form-drawer").addClass("open");
    $("body").addClass("formopen");
  });

  $(document).on("click", ".course-checkout-btn", function () {
    $("#shopify-section-header").css("z-index", "1");

    $(".form-drawer.course-checkout-form").addClass("open");
    $("body").addClass("formopen");
    var order_number = Math.floor(Math.random() * 10000000000);

    $("#course_checkout_Form #order_number").val(order_number);
    $("#form_success").addClass("hidden");
    $("#form_error").addClass("hidden");
    $(".customer-contact-details .field")
      .children("input")
      .attr("disabled", true);
    $("#course_checkout_Form .field").children("input").val("");
    $(".customer-contact-details").addClass("hidden");

    $("#ContactForm-Abweichender_Teilnehmer").prop("checked", false);
    $("#hidden_Abweichender_Teilnehmer").attr("disabled", false);
  });

  $(".form-drawer .close").click(function () {
    $(".form-drawer").removeClass("open");
    $("body").removeClass("formopen");
  });
  $(document).mouseup(function (e) {
    var container = $(".form-drawer");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".form-drawer .close").trigger("click");
    }
  });

  $(".offerte-popup-btn").on("click", function () {
    $("#contact-form-product").trigger("click");
  });

  // product form
  $(".field-checkboxlist .checkboxList input[type=checkbox]").click(
    function () {
      var check_length = $(".checkbox input[type=checkbox]:checked").length;
      if (check_length >= 1) {
        $(this).parents(".checkboxList").find("#ContactForm-body").show();
      } else {
        $(this).parents(".checkboxList").find("#ContactForm-body").hide();
      }
    }
  );

  // fixed header
  var yourNavigation = $(".header-wrapper");
  stickyDiv = "header-fix";
  yourHeader = $(".header-top").height();

  $(window).scroll(function () {
    if ($(this).scrollTop() > yourHeader) {
      yourNavigation.addClass(stickyDiv);
    } else {
      yourNavigation.removeClass(stickyDiv);
    }
  });

  //logo

  $(".logo-wrap").slick({
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
  var slidesToShow = 4;
  if ($(".zubehoer_product_main").length > 0) {
    var dataSlide = $(".zubehoer_product_main").data("slide");

    if (dataSlide <= 3) {
      slidesToShow = 3;
    }
  }

  $(".zubehoer_slider").slick({
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".cross_selling_slider").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $(".top-seller-slick-prev"),
    nextArrow: $(".top-seller-slick-next"),
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  iniSlider();
  $(window).resize(function () {
    iniSlider();
  });

  function iniSlider() {
    if ($(window).width() < 768) {
      $(".zubehoer_mobile_slider").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
      });

      $(".cross_selling_mobile_slider").slick({
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $(".top-seller-slick-prev"),
        nextArrow: $(".top-seller-slick-next"),
        dots: false,
        arrows: true,
      });
    } else {
      $(".zubehoer_mobile_slider.slick-initialized").slick("unslick");
      $(".cross_selling_mobile_slider.slick-initialized").slick("unslick");
    }
  }

  var val = $(".collection-filter .collection-filter-inner span.active").attr(
    "data-value"
  );
  //  console.log(val);

  var lengths = $(".live-course-block a." + val).length;
  //     console.log(lengths);

  $(".collection-kurse .product-count__text").text(lengths + " kurse");

  $(".live-course-block a").hide();
  $(".live-course-block a." + val).show();

  $(".collection-filter .collection-filter-inner span").click(function () {
    $(".collection-filter .collection-filter-inner span")
      .not($(this))
      .removeClass("active");

    $(this).addClass("active");
    var tags = $(this).attr("data-value");
    //   	console.log(tags);
    $("#ProductGridContainer .live-course-block").attr("data-domain", tags);

    $(".live-course-block a").hide();
    if ($(this).hasClass("active")) {
      $(".live-course-block a." + tags).show();
    } else {
      $(".live-course-block a").show();
    }

    if ($(".live-course-block a." + tags).length == 0) {
      $("span.error-msg").show();
    } else {
      $("span.error-msg").hide();
      $(".live-course-block a." + tags).show();
    }

    var length = $(".live-course-block a." + tags).length;
    //     console.log(length);
    if (length == 1) {
      $(".product-count__text").text(length + " Kurs");
    } else {
      $(".product-count__text").text(length + " kurse");
    }
  });

  $('.kurse-tab li a[href^="#"]').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 100,
        },
        400,
        "swing",
        function () {}
      );
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
      $("#scroll").fadeIn();
    } else {
      $("#scroll").fadeOut();
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, "600");
    return false;
  });

  var highestBox = 0;

  $(".zubehoer_products .zubehoer_product_single").each(function () {
    $(this)
      .find(".zubehoer_product_info h3")
      .each(function () {
        if ($(this).height() > highestBox) {
          highestBox = $(this).height();
        }
      });
  });

  $(
    ".zubehoer_products .zubehoer_product_single .zubehoer_product_info h3"
  ).height(highestBox);

  function getQueryStringParameters() {
    var parameters = {},
      hash;
    var q = document.URL.split("?")[1];
    if (q != undefined) {
      q = q.split("&");
      for (var i = 0; i < q.length; i++) {
        hash = q[i].split("=");
        parameters[hash[0]] = hash[1];
      }
    }
    return parameters;
  }

  function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  var parameters = getQueryStringParameters();
  if (isEmpty(parameters) == false) {
    $.each(parameters, function (key, value) {
      if (key == "list") {
        var param = value;
        $(".collection-block #product-grid .course-main").each(function (
          i,
          li
        ) {
          var main = $(this);
          var title = main.find(".Course-description span").text();
          var include = title.includes(param);
          //          console.log(value,include);
          if (include == true) {
          } else {
            main.hide();
          }
        });
      }

      if (key == "type") {
        var param = value;
        console.log(param);
        $(".collection-filter .collection-filter-inner span").removeClass(
          "active"
        );
        $(
          ".collection-filter .collection-filter-inner span[data-value=" +
            param +
            "]"
        ).addClass("active");

        var length = $(".live-course-block a." + param).length;
        if (length == 1) {
          $(".product-count__text").text(length + " Kurs");
        } else {
          $(".product-count__text").text(length + " kurse");
        }

        $(".live-course-block a").hide();

        if ($(".live-course-block a." + param).length == 0) {
          $("span.error-msg").show();
        } else {
          $("span.error-msg").hide();
          $(".live-course-block a." + param).show();
        }
      }
    });
  }
});


settings = {
  //Model Popup
  objModalPopupBtn: ".modalButton",
  objModalCloseBtn: ".overlay, .closeBtn",
  objModalDataAttr: "data-popup",
};

$(document).on("click", ".modalButton", function () {
  if ($(this).attr(settings.objModalDataAttr)) {
    var strDataPopupName = $(this).attr(settings.objModalDataAttr);

    //Fade In Modal Pop Up
    $(".overlay, #" + strDataPopupName).fadeIn();
  }
});

//On clicking the modal background
$(document).on("click", ".overlay, .closeBtn", function () {
  $(".modal").fadeOut();
});

$(window).on("load", function () {
  var curr_lang = $("input#LocaleSelector").val();

  $(
    "#CollectionProductGrid .boost-pfs-filter-options-wrapper .boost-pfs-filter-option"
  ).each(function (i, li) {
    if (curr_lang == "de") {
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-chirurgie-dermatologique"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-dermochirurgia"
      ).hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-corps").hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-corpo").hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-protection-laser"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-protezione-laser"
      ).hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-viso-collo").hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-visage-cou").hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-peli-superflui-pigmentazione-vascolarizzazione"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-pilosite-pigmentation-vascularisation"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-pigmento-da-tatuaggio"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-pigment-de-tatouage"
      ).hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-terapia-uv").hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-traitement-uv"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-champ-d-x27-application"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-area-di-applicazione"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-champ-d-x27-application"
      ).hide();
    }

    if (curr_lang == "fr") {
      //       $('.boost-pfs-filter-option-marke .boost-pfs-filter-button span.boost-pfs-filter-option-title-text').text('MARQUE');

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-dermatochirurgie"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-dermochirurgia"
      ).hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-korper").hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-corpo").hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-protezione-laser"
      ).hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-laserschutz").hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-viso-collo").hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-gesicht-nacken"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-peli-superflui-pigmentazione-vascolarizzazione"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-haare-pigment-vaskular"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-pigmento-da-tatuaggio"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-tatowierung-pigment"
      ).hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-terapia-uv").hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-uv-therapie").hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-anwendungsbereich"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-area-di-applicazione"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-anwendungsbereich"
      ).hide();
    }

    if (curr_lang == "it") {
      //       $('.boost-pfs-filter-option-marke .boost-pfs-filter-button span.boost-pfs-filter-option-title-text').text('MARCA');

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-dermatochirurgie"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-chirurgie-dermatologique"
      ).hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-korper").hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-corps").hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-protection-laser"
      ).hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-laserschutz").hide();

      $(".boost-pfs-filter-option.boost-pfs-filter-option-visage-cou").hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-gesicht-nacken"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-pilosite-pigmentation-vascularisation"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-haare-pigment-vaskular"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-pigment-de-tatouage"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-tatowierung-pigment"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-traitement-uv"
      ).hide();
      $(".boost-pfs-filter-option.boost-pfs-filter-option-uv-therapie").hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-anwendungsbereich"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-champ-d-x27-application"
      ).hide();

      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-anwendungsbereich"
      ).hide();
      $(
        ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-champ-d-x27-application"
      ).hide();
    }
  });
});

$(document).ready(function () {
  const change_productPrice = setInterval(function () {
    if ($(".pre-money").length > 0) {
      if ($(".uvp-price").length > 0) {
        var originalPrice = $(".uvp-price")
          .data("original-price")
          .replace(/[^0-9]/gi, "");
        var discountedPrice = $(".price-item.money")
          .eq(0)
          .text()
          .replace(/[^0-9]/gi, "");
        let originalPrice_num = parseInt(originalPrice);
        let discountedPrice_num = parseInt(discountedPrice);
        //console.log("isNumeric",originalPrice_num,typeof originalPrice_num,discountedPrice_num, typeof discountedPrice_num);
        if (originalPrice_num > discountedPrice_num) {
          //console.log('uvp true');
          $(".uvp-price").removeClass("hidden");
        }
      }

      clearInterval(change_productPrice);
    }
  }, 1500);

  setTimeout(function () {
    $(".thumbnail-slider .thumbnail-list li:first-child button").click();
  }, 200);
});

/*accordian js*/
jQuery(".accordion h5").click(function () {
  jQuery(this)
    .find("i")
    .toggleClass("rotate")
    .closest("h5")
    .next()
    .slideToggle()
    .siblings(".accordion_content")
    .slideup();
});

jQuery(".accordion_content").hide();
function getFormData($form) {
  var unindexed_array = $form.serializeArray();
  var indexed_array = {};

  $.map(unindexed_array, function (n, i) {
    indexed_array[n["name"]] = n["value"];
  });

  return indexed_array;
}

$(document).ready(function () {
  var preurl = document.referrer;

  sessionStorage.setItem("url", preurl);

  var getURL = sessionStorage.getItem("url");
  //console.log('get URL-',getURL);

  if (sessionStorage.getItem("url")) {
    $(".return-link").attr("href", getURL);
  }
});
$(document).ready(function () {
  $(".content-main #tabify-3 a").attr("target", "_blank");

  // aico add
  aico.jq('select[aico_field="account_identity"]').change(function () {
    var selectedValue = aico.jq(this).val();
    var parentForm = aico.jq(this).closest("#aico_form");

    if (parentForm.length > 0) {
      if (selectedValue === "privatkunde") {
        parentForm.find(".form-group").not(this.closest(".form-group")).hide();
        aico.jq("#control-3568775").hide();
      } else {
        parentForm.find(".form-group").show();
        aico.jq("#control-3568775").show();
      }
    }
  });
  // aico end
});

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}


$(document).ready(function() {
  $('.testimonial-v1 .multicolumn-list').slick({
    dots: true,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
     adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>',
  });
});
